import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { INonMovementDescription } from '../interfaces/non-movement-description';

@Injectable({ providedIn: 'root' })
export class NonMovementDescriptionService extends ReadService<any, any> {
  url = '/api/non-movement-description';
  entityTitle = 'Non Movement Description';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getAll(): Promise<INonMovementDescription[]> {
    return this.http
      .get(`${this.url}/all`, { headers: new HttpHeaders({}) })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public create(dto: INonMovementDescription) {
    const url = `${this.url}`;
    return this.handleRequest<number>(
      this.http.post<number>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  public update(id: number, dto: INonMovementDescription) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<number>(
      this.http.put<number>(url, dto),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  public delete(id: number) {
    const url = `${this.url}/${id}`;
    return this.handleRequest<boolean>(
      this.http.delete<boolean>(url),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }
}
